import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";

function YourComponent() {
  const [startMonth, setStartMonth] = useState('');
  const [endMonth, setEndMonth] = useState('');
  const [outcomeData, setOutcomeData] = useState([]);
  const [totalAmountSum, setTotalAmountSum] = useState(0);
  const [prepayAmountSum, setPrepayAmountSum] = useState(0);
  const [restValue, setRestValue] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [year, setYear] = useState('');
  const arabicMonthNames = [
    "يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
    "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
  ];

  // useEffect(() => {
  //   // Fetch data from the API
  //   axios.get("https://subk.education.com.ly/back/api/getTotalAmountByMonth")
  //     .then(response => {
  //       const data = response.data;
  //       setOutcomeData(data);
  //       setFilteredData(data);

  //       // Calculate total amount and prepay amount sums
  //       const totalAmountSum = data.reduce((acc, item) => acc + parseFloat(item.total_amount), 0);
  //       const prepayAmountSum = data.reduce((acc, item) => acc + parseFloat(item.prepay_amount), 0);
  //       setTotalAmountSum(totalAmountSum);
  //       setPrepayAmountSum(prepayAmountSum);
  //       setRestValue(totalAmountSum - prepayAmountSum);
  //     })
  //     .catch(error => {
  //       console.error("Error fetching outcome data:", error);
  //     });
  // }, []);
  const handleSearch = async  () => {
    try {
      const response = await axios.get("https://subk.education.com.ly/back/api/getTotalAmountByMonth", {
        params: {
          start_month: startMonth,
          end_month: endMonth
        }
      });
      setFilteredData(response.data.data);
       setTotalAmountSum(response.data.total_amount_sum);
    setPrepayAmountSum(response.data.prepay_amount_sum);
    } catch (error) {
      console.error('Error fetching data:', error);
      alert('Failed to load report data.');
    }
    
   };
  
;/*
  const handleSearch = () => {
    // Filter outcomeData based on startMonth and endMonth
    const filtered = outcomeData.filter(item => {
      const month = item.month;
      const itemDate = new Date(item.year);

      const itemYear = itemDate.getFullYear();
       const yearFilter = year ? itemYear === parseInt(year) : true;

      const start = parseInt(startMonth, 10) || 1;
      const end = parseInt(endMonth, 10) || 12;
      if (endMonth === '') {
        // If endMonth is not specified, only consider startMonth
        return month === start && yearFilter;
            } else {
        // Otherwise, consider the range between startMonth and endMonth
        return month >= start && month <= end && yearFilter;      }
    });
    setFilteredData(filtered); // Update filteredData state
    const totalAmountSum = filtered.reduce((acc, item) => acc + parseFloat(item.total_amount), 0);
    const prepayAmountSum = filtered.reduce((acc, item) => acc + parseFloat(item.prepay_amount), 0);
    setTotalAmountSum(totalAmountSum);
    setPrepayAmountSum(prepayAmountSum);
    setRestValue(totalAmountSum - prepayAmountSum);
  }
  const handleSearch = () => {
    // Filter outcomeData based on startMonth
    console.log(" befor",filteredData)

    setFilteredData(outcomeData);
    console.log(" after",startMonth)

    const filtered = outcomeData.filter(item => 
      item.month == startMonth
    );
  
    // Update filteredData state
    setFilteredData(filtered);
  console.log("filtered",filtered)
    // Calculate total amount and prepay amount sums from filtered data
    const totalAmountSum = filtered.reduce((acc, item) => acc + parseFloat(item.total_amount), 0);
    const prepayAmountSum = filtered.reduce((acc, item) => acc + parseFloat(item.prepay_amount), 0);
    setTotalAmountSum(totalAmountSum);
    setPrepayAmountSum(prepayAmountSum);
    setRestValue(totalAmountSum - prepayAmountSum);
  };
  
  */

  const handleClearSearch = () => {
    setStartMonth(''); // Reset start month
    setEndMonth(''); // Reset end month
    setFilteredData(outcomeData); // Reset filtered data to original data
    const totalAmountSum = outcomeData.reduce((acc, item) => acc + parseFloat(item.total_amount), 0);
        const prepayAmountSum = outcomeData.reduce((acc, item) => acc + parseFloat(item.prepay_amount), 0);
        setTotalAmountSum(totalAmountSum);
        setPrepayAmountSum(prepayAmountSum);
        setRestValue(totalAmountSum - prepayAmountSum);
  };

  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-3" style={{display :'flex'}}>
          <label htmlFor="startMonth" className="form-label ms-2 mt-1">من</label>
           <input
            type="date"
            value={startMonth}
            onChange={(e) => setStartMonth(e.target.value)}
          />
         </div>
        <div className="col-md-3" style={{display :'flex'}}>
          <label htmlFor="endMonth" className="form-label ms-2 mt-1">ألى</label>
           <input
            type="date"
            value={endMonth}
            onChange={(e) => setEndMonth(e.target.value)}
          />
        </div>
      
        <div className="col-md-3">
          <button className="btn btn-primary btn-sm me-1" onClick={handleSearch}>ابحت</button>
        
           <button className="btn btn-secondary btn-sm me-1" onClick={handleClearSearch}> الغاء</button>
        </div>
      </div>
      <div className="row mb-3" style={{display :'flex'}}>
      <div className="col-md-4" style={{display :'flex'}}>
          <label htmlFor="startMonth" style={{fontsize: '15px', fontWeight: 'bold'}}> اجمالي الدخل :</label>
       <div style={{color: 'blue'}}> <strong>{totalAmountSum}</strong></div>
        </div> 
        <div className="col-md-4" style={{display :'flex'}}>
          <label style={{fontsize: '15px', fontWeight: 'bold'}} htmlFor="startMonth"> اجمالي العرابين :</label>
          <div style={{color: 'red'}}><strong>{prepayAmountSum}</strong></div>
        </div>
        <div className="col-md-4" style={{display :'flex'}}>
          <label style={{fontsize: '15px', fontWeight: 'bold'}} htmlFor="startMonth"> صافي الدخل :</label>
          <div style={{color: 'green'}}><strong>{totalAmountSum-prepayAmountSum}</strong>        </div>
      </div>
      </div>

      {/* Your table code */}
      <Table responsive striped bordered className="verticle-middle">
         <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

          <tr>
            <th>الشهر</th>
            <th>السنة</th>

            <th> اجمالي الدخل</th>
            <th>أجمالي العرابين</th>
          </tr>
        </thead>
      <tbody>
  {filteredData.length > 0 ? (
    filteredData.map((item, index) => (
      <tr key={index}>
        <td>{arabicMonthNames[item.month - 1]}</td>
        <td>{item.year}</td>
        <td>{item.total_amount}</td>
        <td>{item.prepay_amount}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4" className="text-center">لا توجد بيانات مطابقة</td>
    </tr>
  )}
</tbody>

      </Table>
    </div>
  );
}

export default YourComponent;
